module.exports = __webpack_public_path__ + "static/media/playlistsync-macbook-window.a77be056.png";